import { combineReducers } from '@reduxjs/toolkit'
import gameSetting from './slices/gameSettings.slice'
import authSlice from './slices/auth.slice'
import loader from './slices/loader.slice'
import predictionMarket from 'games/PredictionMarket/slice-thunk/predictionMarket.slice'

const rootReducer = combineReducers({
  gameSetting,
  predictionMarket,
  auth: authSlice,
  loader
})

export default rootReducer
